module.exports = __webpack_public_path__ + "img/logo.547f79ab.png";